import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState, selectFeature } from './appointment-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { Appointment } from './models/appointment.model';

@Injectable()
export class AppointmentDataStore extends EntityDataStore<IState, Appointment> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }
}
